import { FC } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { CarbonSnapResultsResponse } from "../../../../../../datasources/carbonsnap/io/response";

interface Props {
	transportData: CarbonSnapResultsResponse["transportData"];
}

const TransportDataSection: FC<Props> = ({ transportData }) => {
	const { t } = useTranslation("whatIf.carbonsnap");

	const formatBoolean = (value: boolean): string => {
		return value ? t("results/data/yes") : t("results/data/no");
	};

	return (
		<Box>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t("results/data/title")}
			</Typography>
			<Paper sx={{ p: 3 }}>
				<Grid container spacing={3}>
					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/total distance")}
						</Typography>
						<Typography variant="h6">
							{transportData.totalDistance.value} {transportData.totalDistance.measure}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/cargo weight")}
						</Typography>
						<Typography variant="h6">
							{transportData.cargoWeight.value} {transportData.cargoWeight.measure}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/intermodal")}
						</Typography>
						<Typography variant="h6">
							{formatBoolean(transportData.isIntermodal)}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/calculation mode")}
						</Typography>
						<Typography variant="h6">
							{transportData.calculationMode}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/trips")}
						</Typography>
						<Typography variant="h6">
							{transportData.numberOfTrips}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/departure date")}
						</Typography>
						<Typography variant="h6">
							{dayjs(transportData.departureDate).format("DD/MM/YYYY")}
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, md: 3 }}>
						<Typography variant="body2" color="text.secondary">
							{t("results/data/temperature")}
						</Typography>
						<Typography variant="h6">
							{transportData.temperature}
						</Typography>
					</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};

export default TransportDataSection;
